import { useCallback, useMemo } from 'react';
import {
  ActivityLabelOptionsQuery,
  useActivityLabelOptionsLazyQuery
} from 'graphql/types';
import { useNoteContext } from 'modules/notes/NoteContext';
import { ACTIVITY_BILLING_PAGE_COUNT } from '../components';

export interface ActivityLabelSearchParams {
  query?: string;
}

export interface UseActivityLabelSearchResultProps {
  searchHandler: (searchParams: ActivityLabelSearchParams) => void;
  data: ActivityLabelOptionsQuery | undefined;

  loading: boolean;
}

export const useActivityLabelSearch = (): UseActivityLabelSearchResultProps => {
  const { date } = useNoteContext();
  const [
    getLabelOptions,
    { data, loading }
  ] = useActivityLabelOptionsLazyQuery();

  const searchHandler = useCallback(
    ({ query }: ActivityLabelSearchParams) => {
      const variables = {
        date: date.toISODate(),
        input: {
          count: ACTIVITY_BILLING_PAGE_COUNT,
          query: query
        }
      };

      getLabelOptions({ variables });
    },
    [date, getLabelOptions]
  );

  return useMemo(
    () => ({
      searchHandler,
      data,
      loading
    }),
    [data, loading, searchHandler]
  );
};
export default useActivityLabelSearch;
